<script lang="ts">
	import imageCoffeePotXs from "@assets/images/about-us-coffee-pot.jpg?webp&h=489&imagetools";
	import imageCoffeePot2Xl from "@assets/images/about-us-coffee-pot.jpg?webp&imagetools";
	import imageCoffeePotXl from "@assets/images/about-us-coffee-pot.jpg?webp&w=640&imagetools";
	import imageFreshXs from "@assets/images/about-us-fresh.jpg?webp&h=489&imagetools";
	import imageFresh2xl from "@assets/images/about-us-fresh.jpg?webp&imagetools";
	import imageFreshXl from "@assets/images/about-us-fresh.jpg?webp&w=640&imagetools";
	import imageHandWithCoffeeXs from "@assets/images/about-us-hand-with-coffee.jpg?webp&h=489&imagetools";
	import imageHandWithCoffeeXl from "@assets/images/about-us-hand-with-coffee.jpg?webp&h=1680&imagetools";
	import imageHandWithCoffee2Xl from "@assets/images/about-us-hand-with-coffee.jpg?webp&imagetools";
	import heroImageXs from "@assets/images/about-us-hero.jpg?webp&h=1000&quality=95&imagetools";
	import heroImageSm from "@assets/images/about-us-hero.jpg?webp&h=1300&quality=90&imagetools";
	import heroImageMd from "@assets/images/about-us-hero.jpg?webp&h=1600&imagetools";
	import heroImageLg from "@assets/images/about-us-hero.jpg?webp&h=1900&imagetools";
	import heroImageXl from "@assets/images/about-us-hero.jpg?webp&imagetools";
	import imagePlantationXs from "@assets/images/about-us-plantation.jpg?webp&h=528&imagetools";
	import imagePlantationLg from "@assets/images/about-us-plantation.jpg?webp&h=1280&imagetools";
	import imagePlantationXl from "@assets/images/about-us-plantation.jpg?webp&imagetools";
	import imagePlantation2Xl from "@assets/images/about-us-plantation.jpg?webp&imagetools";
	import imagePlantationSm from "@assets/images/about-us-plantation.jpg?webp&w=768&imagetools";
	import imagePlantationMd from "@assets/images/about-us-plantation.jpg?webp&w=1024&imagetools";
	import imageRobotXs from "@assets/images/about-us-robot.jpg?webp&h=720&imagetools";
	import imageRobotSm from "@assets/images/about-us-robot.jpg?webp&h=800&imagetools";
	import imageRobotMd from "@assets/images/about-us-robot.jpg?webp&h=880&imagetools";
	import imageRobotLg from "@assets/images/about-us-robot.jpg?webp&h=960&imagetools";
	import imageRobotXl from "@assets/images/about-us-robot.jpg?webp&h=1680&imagetools";
	import imageRobot2Xl from "@assets/images/about-us-robot.jpg?webp&imagetools";
	import imageTeamXs from "@assets/images/about-us-team.jpg?webp&h=720&imagetools";
	import imageTeamSm from "@assets/images/about-us-team.jpg?webp&h=800&imagetools";
	import imageTeamMd from "@assets/images/about-us-team.jpg?webp&h=880&imagetools";
	import imageTeamLg from "@assets/images/about-us-team.jpg?webp&h=960&imagetools";
	import imageTeamXl from "@assets/images/about-us-team.jpg?webp&h=1680&imagetools";
	import imageTeam2Xl from "@assets/images/about-us-team.jpg?webp&imagetools";
	import imageTwoPeopleXs from "@assets/images/about-us-two-people.jpg?webp&h=489&imagetools";
	import imageTwoPeople2Xl from "@assets/images/about-us-two-people.jpg?webp&imagetools";
	import imageTwoPeopleXl from "@assets/images/about-us-two-people.jpg?webp&w=640&imagetools";
	import imageUsXs from "@assets/images/about-us-us.jpg?webp&h=489&imagetools";
	import imageUsLg from "@assets/images/about-us-us.jpg?webp&h=929&imagetools";
	import imageViewXs from "@assets/images/about-us-view.jpg?webp&h=720&imagetools";
	import imageViewSm from "@assets/images/about-us-view.jpg?webp&h=800&imagetools";
	import imageViewMd from "@assets/images/about-us-view.jpg?webp&h=880&imagetools";
	import imageViewLg from "@assets/images/about-us-view.jpg?webp&h=960&imagetools";
	import imageViewXl from "@assets/images/about-us-view.jpg?webp&h=1680&imagetools";
	import imageView2Xl from "@assets/images/about-us-view.jpg?webp&imagetools";
	import imageVillageXs from "@assets/images/about-us-village.jpg?webp&h=720&imagetools";
	import imageVillageSm from "@assets/images/about-us-village.jpg?webp&h=800&imagetools";
	import imageVillageMd from "@assets/images/about-us-village.jpg?webp&h=880&imagetools";
	import imageVillageLg from "@assets/images/about-us-village.jpg?webp&h=960&imagetools";
	import imageVillageXl from "@assets/images/about-us-village.jpg?webp&h=1680&imagetools";
	import imageVillage2Xl from "@assets/images/about-us-village.jpg?webp&imagetools";
	import imageHarvestingXs from "@assets/images/coffee-harvesting.jpg?webp&h=720&imagetools";
	import imageHarvestingSm from "@assets/images/coffee-harvesting.jpg?webp&h=800&imagetools";
	import imageHarvestingMd from "@assets/images/coffee-harvesting.jpg?webp&h=880&imagetools";
	import imageHarvestingLg from "@assets/images/coffee-harvesting.jpg?webp&h=960&imagetools";
	import imageHarvestingXl from "@assets/images/coffee-harvesting.jpg?webp&h=1680&imagetools";
	import imageHarvesting2Xl from "@assets/images/coffee-harvesting.jpg?webp&imagetools";
	import imageProcessingXs from "@assets/images/coffee-processing.jpg?webp&h=720&imagetools";
	import imageProcessingSm from "@assets/images/coffee-processing.jpg?webp&h=800&imagetools";
	import imageProcessingMd from "@assets/images/coffee-processing.jpg?webp&h=880&imagetools";
	import imageProcessingLg from "@assets/images/coffee-processing.jpg?webp&h=960&imagetools";
	import imageProcessingXl from "@assets/images/coffee-processing.jpg?webp&h=1680&imagetools";
	import imageProcessing2Xl from "@assets/images/coffee-processing.jpg?webp&imagetools";
	import imageStoreXs from "@assets/images/coffee-store-no-filter.jpg?webp&h=720&imagetools";
	import imageStoreSm from "@assets/images/coffee-store-no-filter.jpg?webp&h=800&imagetools";
	import imageStoreMd from "@assets/images/coffee-store-no-filter.jpg?webp&h=880&imagetools";
	import imageStoreLg from "@assets/images/coffee-store-no-filter.jpg?webp&h=960&imagetools";
	import imageStoreXl from "@assets/images/coffee-store-no-filter.jpg?webp&h=1680&imagetools";
	import imageStore2Xl from "@assets/images/coffee-store-no-filter.jpg?webp&imagetools";
	import signImage from "@assets/images/sign-marie-petr.png?webp&imagetools";
	import Carousel from "@components/common/Carousel.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import AboutUsContentSection from "@components/sections/AboutUsContentSection.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { SourceSetQuery } from "@core/schema/SourceSetQuery.js";
	import { getCoffeeStoreAnchor } from "@core/schema/paths/getCoffeeStoreAnchor.js";
	import TeamSection from "../team/TeamSection.svelte";
	import translations from "./AboutUs.translations.json" with { type: "json" };
	import type { AboutUsProps } from "./AboutUsProps.js";

	type ImageSources = Partial<Record<SourceSetQuery, string>> & { default: string };

	const translate = getTranslate(translations);
	const { tenant }: AboutUsProps = $props();

	const heroSources = {
		default: heroImageXs,
		">sm": heroImageSm,
		">md": heroImageMd,
		">lg": heroImageLg,
		">xl": heroImageXl,
	};
	const freshSources = { default: imageFreshXs, ">xl": imageFreshXl, ">2xl": imageFresh2xl };
	const robotSources = {
		default: imageRobotXs,
		">sm": imageRobotSm,
		">md": imageRobotMd,
		">lg": imageRobotLg,
		">xl": imageRobotXl,
		">2xl": imageRobot2Xl,
	};
	const twoPeopleSources = { default: imageTwoPeopleXs, ">xl": imageTwoPeopleXl, ">2xl": imageTwoPeople2Xl };
	const teamSources = {
		default: imageTeamXs,
		">sm": imageTeamSm,
		">md": imageTeamMd,
		">lg": imageTeamLg,
		">xl": imageTeamXl,
		">2xl": imageTeam2Xl,
	};
	const usSources = { default: imageUsXs, ">lg": imageUsLg };
	const storeSources = {
		default: imageStoreXs,
		">sm": imageStoreSm,
		">md": imageStoreMd,
		">lg": imageStoreLg,
		">xl": imageStoreXl,
		">2xl": imageStore2Xl,
	};
	const coffeePotSources = { default: imageCoffeePotXs, ">xl": imageCoffeePotXl, ">2xl": imageCoffeePot2Xl };
	const plantationSources = {
		default: imagePlantationXs,
		">sm": imagePlantationSm,
		">md": imagePlantationMd,
		">lg": imagePlantationLg,
		">xl": imagePlantationXl,
		">2xl": imagePlantation2Xl,
	};
	const handWithCoffeeSources = {
		default: imageHandWithCoffeeXs,
		">xl": imageHandWithCoffeeXl,
		">2xl": imageHandWithCoffee2Xl,
	};
	const viewSources = {
		default: imageViewXs,
		">sm": imageViewSm,
		">md": imageViewMd,
		">lg": imageViewLg,
		">xl": imageViewXl,
		">2xl": imageView2Xl,
	};
	const harvestingSources = {
		default: imageHarvestingXs,
		">sm": imageHarvestingSm,
		">md": imageHarvestingMd,
		">lg": imageHarvestingLg,
		">xl": imageHarvestingXl,
		">2xl": imageHarvesting2Xl,
	};
	const villageSources = {
		default: imageVillageXs,
		">sm": imageVillageSm,
		">md": imageVillageMd,
		">lg": imageVillageLg,
		">xl": imageVillageXl,
		">2xl": imageVillage2Xl,
	};
	const processingSources = {
		default: imageProcessingXs,
		">sm": imageProcessingSm,
		">md": imageProcessingMd,
		">lg": imageProcessingLg,
		">xl": imageProcessingXl,
		">2xl": imageProcessing2Xl,
	};

	const mobileGalleryImages: ImageSources[] = [
		robotSources,
		teamSources,
		storeSources,
		plantationSources,
		viewSources,
		harvestingSources,
		villageSources,
		processingSources,
	];

	function getSourcesetOnly(sources: ImageSources): Partial<Record<SourceSetQuery, string>> {
		const { default: _, ...sourceset } = sources;
		return sourceset;
	}
</script>

<Layout>
	<ImageSection
		lcp
		darkOverlay={false}
		class="md:!h-[calc(100vh-6rem)] [&_:is(h1,p)]:!text-fcrdarkgray"
		sources={heroSources}
	/>

	<AboutUsContentSection heading={translate("heroHeading")} class="bg-fcrbeige">
		<Formatted text={translate("heroParagraph")} />

		{#snippet media()}
			{@const { default: src, ...sourcesets } = freshSources}
			<Media
				width={684}
				height={4560}
				source={{ type: "image/webp", src }}
				alt={translate("imageGettingResources")}
				class="size-full object-cover"
				wrapperClass="absolute inset-0 object-cover"
				{sourcesets}
			/>
		{/snippet}
	</AboutUsContentSection>

	<ImageSection class="hidden md:block md:!h-[calc(100vh-6rem)]" sources={robotSources} darkOverlay={false} />

	<AboutUsContentSection heading={translate("ourTechnologyHeading")} imageLeft>
		<Formatted text={translate("ourTechnologyParagraph")} />

		{#snippet media()}
			{@const { default: src, ...sourcesets } = twoPeopleSources}
			<Media
				width={400}
				height={350}
				source={{ type: "image/webp", src }}
				alt={translate("imageTwoPeopleAlt")}
				class="size-full object-cover"
				wrapperClass="absolute inset-0 object-cover"
				{sourcesets}
			/>
		{/snippet}
	</AboutUsContentSection>

	<TeamSection title={translate("ourTeam")} class="bg-fcrbeige" />

	<ImageSection class="hidden md:block md:!h-[calc(100vh-6rem)]" sources={teamSources} darkOverlay={false} />

	<AboutUsContentSection heading={translate("ourTeamHeading")} class="bg-fcrbeige">
		<Formatted text={translate("ourTeamParagraph")} />

		{#snippet media()}
			{@const { default: src, ...sourcesets } = usSources}
			<Media
				width={400}
				height={350}
				source={{ type: "image/webp", src }}
				alt={translate("imageUsAlt")}
				class="size-full object-cover"
				wrapperClass="absolute inset-0 object-cover"
				{sourcesets}
			/>
		{/snippet}
	</AboutUsContentSection>

	<ImageSection class="hidden md:block md:!h-[calc(100vh-6rem)]" sources={storeSources} darkOverlay={false} />

	<AboutUsContentSection
		heading={translate("ourStoreHeading")}
		imageLeft
		mediaClass="!w-171 !h-114"
		anchor={getCoffeeStoreAnchor(tenant.locale)}
	>
		<Formatted text={translate("ourStoreParagraph")} />

		{#snippet media()}
			{@const { default: src, ...sourcesets } = coffeePotSources}
			<Media
				width={400}
				height={350}
				source={{ type: "image/webp", src }}
				alt={translate("imageCoffeePotAlt")}
				class="size-full object-cover"
				wrapperClass="absolute inset-0 object-cover"
				{sourcesets}
			/>
		{/snippet}
	</AboutUsContentSection>

	<ImageSection class="hidden md:block md:!h-[calc(100vh-6rem)]" sources={plantationSources} darkOverlay={false} />

	<AboutUsContentSection heading={translate("weSupportProjectsHeading")} class="bg-fcrbeige">
		<div>
			<Formatted text={translate("weSupportStory1")} />
		</div>
		<div class="mt-6">
			<Formatted text={translate("weSupportStory2")} />
		</div>

		{#snippet media()}
			{@const { default: src, ...sourcesets } = handWithCoffeeSources}
			<Media
				width={400}
				height={350}
				source={{ type: "image/webp", src }}
				alt={translate("imageHandWithCoffeeAlt")}
				class="size-full object-cover"
				wrapperClass="absolute inset-0 object-cover"
				{sourcesets}
			/>
		{/snippet}
	</AboutUsContentSection>

	<Media
		source={{ type: "image/webp", src: viewSources.default }}
		sourcesets={getSourcesetOnly(viewSources)}
		width={1920}
		height={1080}
		alt=""
		wrapperClass="full-width hidden md:block"
		class="h-screen w-full full-width object-cover"
	/>

	<div class="full-width">
		<div class="grid-cols-3 hidden md:grid">
			<Media
				source={{ type: "image/webp", src: harvestingSources.default }}
				sourcesets={getSourcesetOnly(harvestingSources)}
				width={560}
				height={700}
				class="w-full h-full"
				alt=""
			/>
			<Media
				source={{ type: "image/webp", src: villageSources.default }}
				sourcesets={getSourcesetOnly(villageSources)}
				width={560}
				height={700}
				class="w-full h-full"
				alt=""
			/>
			<Media
				source={{ type: "image/webp", src: processingSources.default }}
				sourcesets={getSourcesetOnly(processingSources)}
				width={560}
				height={700}
				class="w-full h-full"
				alt=""
			/>
		</div>

		<div class="md:hidden full-width">
			<Carousel items={mobileGalleryImages} options={{ loop: true, align: "start" }}>
				{#snippet item(sources: ImageSources)}
					{@const { default: src, ...sourcesets } = sources}
					<div class="w-[85vw] h-80 px-1">
						<Media
							lightbox="about-us"
							source={{ type: "image/webp", src }}
							{sourcesets}
							alt=""
							width={400}
							height={320}
							class="size-full object-cover"
						/>
					</div>
				{/snippet}
			</Carousel>
		</div>

		<div class="full-width overflow-hidden">
			<div
				class="text-fcrdarkgray font-antipol text-center leading-tighter text-3.5xl sm:text-6.5xl max-w-86 mx-auto sm:max-w-166 relative mt-27.5 mb-40"
			>
				<Formatted text={translate("thanks")} />
				<Media
					source={{ type: "image/webp", src: signImage }}
					sourcesets={{ ">sm": signImage }}
					alt="Podepsáno"
					width={166}
					height={96}
					class="w-65.5 h-25 md:w-98.25 md:h-37 lg:w-131 lg:h-49 object-contain"
					wrapperClass="absolute right-0 md:translate-x-1/4 lg:translate-x-1/3 -bottom-30 -rotate-6"
				/>
			</div>
		</div>
	</div>
</Layout>
